import { z } from "zod";
import type { RoleRef } from "@/app/roles/types";

export type Invitation = {
  invitation_id: string;
  invitee_email: string;
  org_id: string;
  project_id: string;
  expires_at: string;
  /** Present only when operator-RBAC is enabled for the org. */
  role?: RoleRef;
};

export type MyInvitation = {
  invitation_id: string;
  inviter_name: string;
  inviter_email: string;
  invitee_email: string;
  org_id: string;
  org_name: string;
  project_id: string;
  project_name: string;
  expires_at: string;
  first_invite: boolean;
};

export type GroupedInvitation = {
  project_id: string;
  project_name: string;
  org_id: string;
  org_name: string;
  primary_invitation_id: string;
  inviters: Array<{
    invitation_id: string;
    name: string;
    email: string;
  }>;
  expires_at: string;
};

export type InvitationListData = {
  items: Invitation[];
  count: number;
};

export type MyInvitationListData = {
  items: MyInvitation[];
  count: number;
};

export type InvitationListResponse = {
  code: number;
  msg: string;
  data: InvitationListData;
};

export type MyInvitationListResponse = {
  code: number;
  msg: string;
  data: MyInvitationListData;
};

export type CreateInvitationResponse = {
  invitation_id: string;
  invitee_email: string;
  expires_at: string;
  org_id: string;
  project_id: string;
};

export const createInvitationSchema = z.object({
  email: z.string().email("Invalid email address"),
  // Required by the backend only when RBAC is enabled; the modal supplies a
  // default role in that case and omits the field entirely otherwise.
  role: z.string().optional(),
});

export type CreateInvitationFormValues = z.infer<typeof createInvitationSchema>;
